import { createFileRoute } from "@tanstack/react-router";

import { PageTitle } from "@/components/PageTitle";

export const Route = createFileRoute(
  "/$organizationKey/$dossierId/outcome/$questionnaireId/scores",
)({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <>
      <PageTitle title="outcomeScores" />
      <div>Hello "/$organizationKey/$dossierId/outcome/$questionnaireId/scores"!</div>
    </>
  );
}
